export default __webpack_public_path__ + "static/media/stargreyhover.ca6f10de.png";